import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    emoji: '💜',
    title: 'Mamá e Hija',
    subtitle: '100 Citas especiales',
    desc: 'Actividades, conversaciones y momentos únicos para fortalecer el vínculo entre mamá e hija.',
    color: 'from-purple-500/20 to-purple-900/20',
    border: 'border-purple-500/30'
  }, {
    emoji: '💙',
    title: 'Mamá e Hijo',
    subtitle: '100 Citas especiales',
    desc: 'Ideas y experiencias diseñadas para conectar de verdad entre mamá e hijo.',
    color: 'from-blue-500/20 to-blue-900/20',
    border: 'border-blue-500/30'
  }, {
    emoji: '💖',
    title: 'Papá e Hija',
    subtitle: '100 Citas especiales',
    desc: 'Momentos pensados para crear recuerdos inolvidables entre papá e hija.',
    color: 'from-red-500/20 to-red-900/20',
    border: 'border-red-500/30'
  }, {
    emoji: '💚',
    title: 'Papá e Hijo',
    subtitle: '100 Citas especiales',
    desc: 'Aventuras, charlas y actividades para fortalecer la relación entre papá e hijo.',
    color: 'from-emerald-500/20 to-emerald-900/20',
    border: 'border-emerald-500/30'
  }, {
    emoji: '🎁',
    title: '7 Bonos Exclusivos',
    subtitle: 'Incluidos gratis',
    desc: 'Juegos, frases con propósito, historias familiares y 52 planes mágicos para todo el año.',
    color: 'from-orange-500/20 to-orange-900/20',
    border: 'border-orange-500/30'
  }, {
    emoji: '💫',
    title: '+500 Ideas',
    subtitle: 'Para toda la familia',
    desc: 'Más de 500 ideas listas para usar. Solo elegís una cita, la compartís y disfrutás.',
    color: 'from-yellow-500/20 to-yellow-900/20',
    border: 'border-yellow-500/30'
  }];
  const includes = ['💬 Charlar más y conectar de verdad', '😄 Crear recuerdos inolvidables', '💖 Fortalecer la confianza', '⏰ Aprovechar el tiempo juntos', '🌈 Recuperar la alegría', '✨ Salir de la rutina', '🧠 Entender más a tus hijos', '🎯 Ahorrar tiempo planificando'];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-265">
      <div className="max-w-7xl mx-auto" data-id="element-266">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-267">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-purple-500/20 text-purple-400 mb-6 shadow-[0_0_20px_rgba(168,85,247,0.2)] text-3xl" data-id="element-268">
            💖
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-269">
            PACK 100 CITAS FAMILIARES
          </h2>
          <p className="text-xl text-purple-300 font-medium mb-2" data-id="element-270">
            4 Libros digitales + 7 Bonos
          </p>
          <p className="text-lg text-slate-400" data-id="element-271">
            Llenos de conexión — cada uno pensado para fortalecer la relación
            entre padres e hijos.
          </p>
        </motion.div>

        <div className="text-center mb-12" data-id="element-272">
          <h3 className="text-2xl font-bold text-white" data-id="element-273">
            📚 LO QUE INCLUYE EL PACK
          </h3>
        </div>

        {/* Tomo Cards */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 mb-16" data-id="element-274">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className={`bg-gradient-to-b ${tomo.color} border ${tomo.border} rounded-2xl p-4 md:p-6 backdrop-blur-sm hover:-translate-y-1 transition-transform duration-300`} data-id="element-275">
              <div className="text-2xl md:text-4xl mb-2 md:mb-4" data-id="element-276">
                {tomo.emoji}
              </div>
              <h4 className="text-base md:text-xl font-bold text-white mb-1" data-id="element-277">
                {tomo.title}
              </h4>
              <p className="text-xs md:text-sm font-semibold text-slate-300 mb-2 md:mb-4 pb-2 md:pb-4 border-b border-white/10" data-id="element-278">
                {tomo.subtitle}
              </p>
              <p className="text-slate-300 text-xs md:text-sm leading-relaxed" data-id="element-279">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        {/* Cada tomo incluye */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.3
      }} className="bg-navy-950 border border-purple-900/50 rounded-3xl p-6 md:p-12 max-w-4xl mx-auto relative overflow-hidden shadow-2xl" data-id="element-280">
          <div className="absolute top-0 right-0 w-64 h-64 bg-purple-600/10 rounded-full blur-3xl pointer-events-none" data-id="element-281" />
          <h4 className="text-2xl font-bold text-center mb-8 relative z-10" data-id="element-282">
            ¿Qué vas a lograr?
          </h4>
          <div className="grid md:grid-cols-2 gap-4 relative z-10" data-id="element-283">
            {includes.map((item, index) => <div key={index} className="flex items-start gap-3 bg-navy-900/50 p-4 rounded-xl border border-navy-800" data-id="element-284">
                <CheckCircle2 className="w-5 h-5 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-285" />
                <span className="text-slate-300" data-id="element-286">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}